module.exports = __webpack_public_path__ + "img/en-pc-step-4.a77a2b3e.png";